module.exports = __webpack_public_path__ + "media/images/service de repassage-59b758ba0d12b84b5b03caa0efee775a.svg";